import React from "react"
import SEO from "../components/SEO"
import Header from "../features/web-ttmi/Header"
import Footer from "../features/web-ttmi/Footer"
import { CheckCircle2, Ticket, Users } from "lucide-react"
import {
  FEATURED_PROMOTION,
  PROMOTION_COMMUNITY_ITEMS,
  PROMOTION_GUIDE_STEPS,
  PROMOTION_ITEMS,
  WEBSITE,
} from "../constants"

const Promtion: React.FC = () => {
  return (
    <>
      <SEO
        title={`Khuyến mãi`}
        description="Khám phá ngay hàng nghìn mã giảm giá TuTiMi mỗi ngày."
        keywords="TuTiMi khuyến mãi, mã giảm giá TuTiMi, voucher TuTiMi"
      />

      <Header />
      <div className="min-h-screen bg-[#f8fafc] text-support-dark pb-20 font-sans">
        <main className="mx-auto max-w-6xl px-4 pt-10">
          {/* Featured Banner - Elevated & Immersive */}
          <section className="mb-14 relative group rounded-3xl overflow-hidden shadow-[0_20px_40px_-15px_rgba(31,65,113,0.2)]">
            <img
              src={FEATURED_PROMOTION.image}
              alt={FEATURED_PROMOTION.title}
              className="h-[300px] sm:h-[400px] md:h-[500px] w-full object-cover"
            />
          </section>

          {/* Promotions Grid - Premium Cards */}
          <section id="promotion-grid" className="mb-20">
            {/* Elegant Divider Title */}
            <div className="mb-10 flex items-center justify-center relative">
              <div className="h-px flex-grow bg-gradient-to-r from-transparent via-gray-300 to-transparent opacity-50"></div>
              <div className="absolute flex flex-col items-center">
                <span className="bg-[#f8fafc] px-6 text-center text-2xl md:text-3xl font-extrabold uppercase tracking-widest text-[#1f4171]">
                  Mã Giảm Giá TuTiMi
                </span>
                <span className="mt-1 text-sm font-medium text-gray-400 tracking-[0.2em] uppercase">
                  Tháng 04/2026
                </span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3 lg:grid-cols-4 mt-16">
              {PROMOTION_ITEMS.map((item, i) => (
                <a
                  key={item.id}
                  href={item.href}
                  className="group relative block overflow-hidden rounded-2xl bg-white shadow-[0_4px_20px_-10px_rgba(0,0,0,0.1)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_-15px_rgba(31,65,113,0.3)] ring-1 ring-gray-50"
                  style={{ animationDelay: `${i * 100}ms` }}
                >
                  <div className="overflow-hidden aspect-[4/5] bg-gray-100">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    <div className="absolute bottom-6 left-0 right-0 flex justify-center transform translate-y-8 transition-transform duration-500 ease-out group-hover:translate-y-0">
                      <span className="flex items-center gap-2 rounded-xl bg-white px-5 py-2.5 text-[13px] font-bold uppercase tracking-wide text-primary-navy shadow-xl">
                        <Ticket className="w-4 h-4" />
                        Nhận Ưu Đãi
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </section>

          {/* Guide Section - Glassmorphism Style */}
          <section className="mb-20">
            <div className="mx-auto max-w-4xl relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl transform -rotate-1 scale-105 opacity-50 blur-lg"></div>
              <div className="relative rounded-3xl bg-white p-8 md:p-12 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white">
                <div className="flex flex-col items-center mb-8">
                  <div className="w-12 h-12 bg-blue-50 text-blue-500 rounded-full flex items-center justify-center mb-4">
                    <CheckCircle2 className="w-6 h-6" />
                  </div>
                  <h3 className="text-center text-xl md:text-2xl font-bold uppercase tracking-wider text-primary-navy">
                    Hướng Dẫn Nhận Mã
                  </h3>
                </div>

                <ul className="space-y-4 text-[15px] md:text-[16px] text-gray-600">
                  {PROMOTION_GUIDE_STEPS.map(step => (
                    <li
                      key={step}
                      className="flex items-start bg-slate-50 rounded-2xl p-4 transition-colors hover:bg-blue-50/50"
                    >
                      <div className="mr-4 mt-0.5 w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-white shadow-sm text-blue-500 font-bold text-xs border border-blue-100">
                        ✓
                      </div>
                      <span className="leading-relaxed font-medium">
                        {step}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>

          {/* Community Section - Dynamic Cards */}
          <section className="pt-10 mb-10">
            <div className="mb-10 text-center flex flex-col items-center">
              <Users className="w-8 h-8 text-gray-400 mb-3" />
              <h2 className="text-xl font-bold uppercase tracking-widest text-[#1f4171]">
                Cộng Đồng TuTiMi
              </h2>
            </div>

            <div className="grid gap-6 md:gap-8 md:grid-cols-3">
              {PROMOTION_COMMUNITY_ITEMS.map((item, idx) => (
                <div
                  key={item.id}
                  className="group flex flex-col items-center rounded-3xl bg-white overflow-hidden shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 transition-all duration-500 hover:shadow-[0_20px_40px_-15px_rgba(31,65,113,0.15)] hover:-translate-y-2"
                >
                  <div className="w-full relative h-[180px] overflow-hidden">
                    <div className="absolute inset-0 bg-primary-navy/20 mix-blend-multiply z-10 group-hover:bg-transparent transition-colors duration-500"></div>
                    <img
                      src={
                        PROMOTION_ITEMS[idx]?.image || FEATURED_PROMOTION.image
                      }
                      alt={item.title}
                      className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-col flex-grow px-6 py-8 w-full text-center">
                    <h4 className="mb-3 text-lg font-extrabold uppercase text-primary-navy tracking-wide">
                      {item.title}
                    </h4>
                    <p className="mb-8 flex-grow text-sm leading-relaxed text-gray-500">
                      {item.description}
                    </p>
                    <a
                      href={item.href}
                      className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-50 py-3.5 text-sm font-bold uppercase tracking-wide text-primary-navy transition-all duration-300 hover:bg-primary-navy hover:text-white"
                    >
                      {item.ctaLabel}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </>
  )
}

export default Promtion
